import '@/main.css'
import 'floating-vue/dist/style.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import PrettyPrint from './components/library/elements/PrettyPrint.vue'
// import * as Sentry from '@sentry/vue
import App from './App.vue'
import router from '@/router'
import { useAuthStore } from '@/state/AuthStore'
import { createHead } from '@unhead/vue'
import FloatingVue from 'floating-vue'

const pinia = createPinia()

const queryClientOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false
      }
    }
  }
}

document.documentElement.classList.add('dark')

const app = createApp(App)
const head = createHead()

const appVersion = __APP_VERSION__
app.config.globalProperties.$appVersion = appVersion

// Sentry.init({
//   app,
//   dsn: 'https://9683cc7417a0bf95bba58d25726cf824@o4508607809454080.ingest.us.sentry.io/4508608409501696',
//   // debug: import.meta.env.DEV,
//   logErrors: import.meta.env.DEV,

//   environment: import.meta.env.DEV ? 'development' : 'production',
//   release: 'ribis-client@' + appVersion,
//   integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
//   tracesSampleRate: 1.0,
//   tracePropagationTargets: ['localhost', /^https:\/\/([a-z0-9-]+\.)?ribis\.lol/],
//   replaysSessionSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
//   replaysOnErrorSampleRate: 1.0
// })

app.use(pinia)
app.use(VueQueryPlugin, queryClientOptions)
app.component('PrettyPrint', PrettyPrint)
app.use(head)
app.use(router)
app.use(FloatingVue)

async function bootstrap() {
  const authStore = useAuthStore()
  await authStore.loadTokens()
  app.mount('#app')
}

bootstrap()
